export default __webpack_public_path__ + "static/media/logo_metamask.c901ad35.svg";